/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum CONN_TYPE_VALUES {
  POSTGRES = "postgresql",
  MYSQL = "mysql",
  MSSQL = "mssql",
  MARIADB = "mariadb",
  ORACLE = "oracle",
  CLICKHOUSE = "clickhouse",
  DRUID = "druid",
  IGNITE = "ignite",
  REDSHIFT = "redshift",
  BIGQUERY = "bigquery",
  GOOGLESHEETS = "googlesheets",
  ELASTICSEARCH = "elasticsearch",
  MONGODB = "mongodb",
  SNOWFLAKE = "snowflake",
}
